export default __webpack_public_path__ + "8c8f3bdfb8953e998041c3fa91c8c244.png";